/**
 * Element UI 弹窗拖拽指令：v-dialog-drag
 * 按住标题栏可拖动对话框；关闭后位置复位，下次打开仍居中。
 */
function getStyle(dom, attr) {
  return window.getComputedStyle
    ? window.getComputedStyle(dom, false)[attr]
    : dom.currentStyle[attr]
}

function parsePos(value, axisSize) {
  if (!value || value === 'auto') return 0
  if (String(value).includes('%')) {
    return (axisSize * parseFloat(value)) / 100
  }
  return parseFloat(value) || 0
}

export default {
  bind(el) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    if (!dialogHeaderEl || !dragDom) return

    dialogHeaderEl.style.cursor = 'move'
    dialogHeaderEl.style.userSelect = 'none'

    // 关闭弹窗时复位位置，避免下次打开仍停在上次拖动处
    const resetPosition = () => {
      dragDom.style.left = ''
      dragDom.style.top = ''
      dragDom.style.marginTop = ''
    }

    const observer = new MutationObserver(() => {
      if (el.style.display === 'none') {
        resetPosition()
      }
    })
    observer.observe(el, { attributes: true, attributeFilter: ['style'] })
    el.__dialogDragObserver = observer

    dialogHeaderEl.onmousedown = e => {
      // 鼠标相对标题栏左上角
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      const dragDomWidth = dragDom.offsetWidth
      const dragDomHeight = dragDom.offsetHeight
      const screenWidth = document.documentElement.clientWidth
      const screenHeight = document.documentElement.clientHeight

      const minDragDomLeft = dragDom.offsetLeft
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth
      const minDragDomTop = dragDom.offsetTop
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight

      let styL = parsePos(getStyle(dragDom, 'left'), screenWidth)
      let styT = parsePos(getStyle(dragDom, 'top'), screenHeight)

      document.onmousemove = ev => {
        let left = ev.clientX - disX
        let top = ev.clientY - disY

        if (-left > minDragDomLeft) {
          left = -minDragDomLeft
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }

        dragDom.style.left = `${left + styL}px`
        dragDom.style.top = `${top + styT}px`
        dragDom.style.marginTop = '0'
      }

      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }

      return false
    }
  },

  unbind(el) {
    if (el.__dialogDragObserver) {
      el.__dialogDragObserver.disconnect()
      delete el.__dialogDragObserver
    }
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    if (dialogHeaderEl) {
      dialogHeaderEl.onmousedown = null
    }
  }
}
